import React from 'react';

import WarningIcon from '@mui/icons-material/Warning';
import { Grid, Typography, Tooltip } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { FieldMailFormatter, FieldNameFormatter } from 'common/components';
import { CustomTable } from 'common/components/tables';
import { StripedRow } from 'common/components/tables/Rows';

import * as actions from '../actions';

const StatusFormatter = (cell, t) => (
    <>
        {cell && (
            <Grid container>
                <Grid size={6}>
                    <Typography variant="subtitle2" title={cell && cell.status}>
                        {cell ? cell.status : '- - -'}
                    </Typography>
                </Grid>

                {cell.has_tmp_password && (
                    <Grid size={6}>
                        <Typography>
                            <Tooltip
                                arrow
                                title={t('Active temporary password')}
                            >
                                <WarningIcon />
                            </Tooltip>
                        </Typography>
                    </Grid>
                )}
            </Grid>
        )}
    </>
);

const UsersPreviewTable = ({
    companyId,
    handleClickUpdate,
    handleSortable,
    isFetching,
    items,
    sortedBy,
    pagination,
    orderdBy,
}) => {
    const { t } = useTranslation();
    const columns = [
        {
            dataField: 'full_name',
            formatter: FieldNameFormatter,
            handleSortable: handleSortable,
            sortable: true,
            label: t('Name'),
            width: '10%',
        },
        {
            dataField: 'email',
            formatter: FieldMailFormatter,
            handleSortable: handleSortable,
            sortable: true,
            label: t('Mail'),
            width: '10%',
        },
        {
            dataField: 'company_group_name',
            formatter: FieldNameFormatter,
            handleSortable: handleSortable,
            sortable: true,
            label: t('Role'),
            width: '10%',
        },
        {
            dataField: 'company_group_level',
            formatter: FieldNameFormatter,
            handleSortable: handleSortable,
            sortable: true,
            label: t('Rol level'),
            width: '10%',
        },
        {
            dataField: 'created_at',
            formatter: FieldNameFormatter,
            handleSortable: handleSortable,
            sortable: true,
            label: t('Discharge date'),
            width: '10%',
        },
        {
            dataField: 'is_enabled',
            formatter: (_, { is_enabled }) => StatusFormatter(is_enabled, t),
            handleSortable: handleSortable,
            sortable: true,
            label: t('Status'),
            headerAlign: 'center',
            width: '10%',
        },
    ];

    return (
        <CustomTable
            columns={columns}
            data={items}
            emptyText={t('No records found')}
            handleClickRow={(item) => handleClickUpdate(companyId, item)}
            isFetching={isFetching}
            showTextFilter={true}
            tableRowComponent={StripedRow}
            pagination={pagination}
            sortedBy={sortedBy}
            orderdBy={orderdBy}
        />
    );
};

UsersPreviewTable.propTypes = {
    companyId: PropTypes.string,
    handleClickUpdate: PropTypes.func,
    handleSortable: PropTypes.func,
    isFetching: PropTypes.bool,
    items: PropTypes.array,
    pagination: PropTypes.object,
    sortedBy: PropTypes.string,
    orderdBy: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
    handleClickUpdate: (companyId, item) =>
        dispatch(actions.prepareUpdate(companyId, item)),
});

export default connect(null, mapDispatchToProps)(UsersPreviewTable);
